import { requestBlogCmsTicket } from "@/services/blog-cms";
import { classifyTicketFailure, frameOriginOf, type TicketFailure } from "./protocol";
import { rememberBlogCmsOrigin } from "./session-logout";

export type OpenInNewTabResult =
  | { ok: true }
  | { ok: false; failure: TicketFailure | { reason: "blocked" } };

/**
 * M1-3. The tab is opened before any `await`, inside the user's click or keydown, so it keeps the
 * transient activation a pop-up blocker looks for. A fresh ticket is minted per open (spec §8).
 */
export async function openBlogCmsInNewTab(): Promise<OpenInNewTabResult> {
  const tab = window.open("about:blank", "_blank");
  if (!tab) {
    return { ok: false, failure: { reason: "blocked" } };
  }
  // Reverse tabnabbing: the editor tab gets no handle on admin.
  tab.opener = null;

  try {
    const { url } = await requestBlogCmsTicket({});
    // The new tab's C5 lands in this browser's cookie jar, so admin logout must clear it too.
    rememberBlogCmsOrigin(frameOriginOf(url));
    tab.location.href = url;
    return { ok: true };
  } catch (error) {
    tab.close();
    return { ok: false, failure: classifyTicketFailure(error) };
  }
}
